import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
// redux
import { store, persistor } from './redux/store';
// components
import ScrollToTop from './components/scroll-to-top';
import { MotionLazyContainer } from './components/animate';
import { AuthProvider } from './auth/JwtContext';
import ThirdPartyScripts from './components/ThirdPartyScripts';
// wrapper
import AppWrapper from './AppWrapper';

// ----------------------------------------------------------------------

export default function App() {
  // Lazy load i18n only when needed (not for landing page)
  import('./locales/i18n');

  return (
    <AuthProvider>
      <HelmetProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <ScrollToTop />
              <MotionLazyContainer>
                <ThirdPartyScripts />
                <AppWrapper />
              </MotionLazyContainer>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </HelmetProvider>
    </AuthProvider>
  );
}
